<template>
    <div class="package-selection">

        <div class="row">
            <div class="mb-3 col-sm-3" v-for="pack in packages" :key="pack.id">
                <div class="card package" :style="{ backgroundColor: pack.color }" :class="{ selected: pack.selected, unselected: pack.hasOwnProperty('selected') && !pack.selected }" @click="selectPackage(pack)">
                    <div class="card-body p-2">
                        <h4 class="card-title mb-0" :class="getTextColorClass(pack.color)">{{ pack.description }}</h4>
                    </div>
                </div>
            </div>
        </div>
        <div class="card mb-3 table-card bg-light overflow-hidden">
            <div class="card-header py-3 border-bottom bg-white">
                <div class="row">
                    <div class="col-lg-6 col-12">
                        <select
                            v-if="filteredCube.length"
                            class="form-select"
                            aria-label="Select segment"
                            v-model.number="selectedLayer"
                        >
                            <option
                                v-for="(layer, index) in filteredCube"
                                :key="index"
                                :value="cube.indexOf(layer)"
                            >
                                {{ getTitle(layer.title) }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="card-body p-0">
                <template v-for="(layer, index) in cube" :key="index">
                    <table class="table table-responsive m-0" :style="{display: (index === selectedLayer) ? 'table' : 'none'}" v-if="layer && layer.data && layer.data.length > 0">
                        <thead>
                            <tr class="bg-light">
                                <th colspan="2"></th>
                                <th :colspan="layer.data[0].data.length + 1" style="text-align: center" v-if="layer.header && layer.header.columns && layer.header.columns.title">{{ getTitle(layer?.header?.columns?.title || '') }}</th>
                            </tr>
                            <tr class="bg-light">
                                <th colspan="2"></th>
                                <th v-for="column in layer.header.columns.data" :key="column" class="fw-normal small" v-if="layer.header && layer.header.columns && layer.header.columns.data">{{ column }}</th>
                                <th class="fw-normal small">Selected</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, rindex) in layer.data" :key="rindex">
                                <th :rowspan="layer.data.length" v-if="rindex === 0" 
                                    style="width: 40px; max-width: 40px;" class="bg-light text-center align-middle border-end">
                                    <div class="d-flex align-items-center justify-content-center rotate-90 text-nowrap" v-if="layer.header && layer.header.title">{{ getTitle(layer?.header?.title || '') }}</div></th>
                                <th scope="row" class="bg-light fw-normal small align-middle border-end">{{ row.heading }}</th>
                                <td v-for="(column, cindex) in row.data" :key="cindex"
                                    :class="[
                                        { selectable: hasSelectedPackage() && canEdit('direct_mail'), data: true },
                                        column.color ? getTextColorClass(column.color) : 'bg-white'
                                    ]" 
                                    class="align-middle px-3 " style="height: 54px;"
                                    :style="{ backgroundColor: column.color }"  
                                    ref="columns" 
                                    @select="selectData(column, index, rindex, cindex)" 
                                    @deselect="deselectData(column, index, rindex, cindex)">
                                    {{ number_with_zero(column.count) }}
                                </td>
                                <th class="bg-light align-middle" style="line-height: 1.2em; height: 54px;">
                                    <span>{{number_with_zero(isNaN(row.selected) ? 0 : (row.selected || 0))}} 
                                    <template v-if="row.hasOwnProperty('cost')">
                                        <br>
                                        <span class="text-muted fw-normal">({{currency_with_zero(isNaN(row.cost) ? 0 : (row.cost || 0))}})</span>
                                    </template>
                                    </span>
                                </th>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr class="border-bottom-0">
                                <th scope="row" colspan="2" style="border-bottom: none;"></th>
                                <th v-for="column in layer.footer.data" :key="column" class="align-middle border-bottom-0" style="line-height: 1.2em; height: 54px;" v-if="layer.footer && layer.footer.data">
                                    <span>{{number_with_zero(isNaN(column.selected) ? 0 : (column.selected || 0))}}
                                    <template v-if="column.hasOwnProperty('cost')">
                                        <br>
                                        <span class="text-muted fw-normal">({{currency_with_zero(isNaN(column.cost) ? 0 : (column.cost || 0))}})</span>
                                    </template>
                                    </span>
                                </th>
                                <th class="border-bottom-0">
                                    <span>{{ number_with_zero(isNaN(totalSelected(index)) ? 0 : totalSelected(index)) }}
                                    <br>
                                    <span class="text-muted fw-normal">({{currency_with_zero(isNaN(totalCost(index)) ? 0 : totalCost(index))}})</span></span>
                                </th>
                            </tr>
                        </tfoot>
                    </table>
                </template>
            </div>
        </div>
        <div class="button-wrapper">
            <div class="row">
                <div class="col-12">
                    <div class="step-listing d-flex align-items-center mb-2" style="width: 100%;">
                        <div class="flex-fill" style="width: 50%;">
                            Segment {{ currentLayerIndex + 1 }} of {{ filteredCube.length }}
                        </div>
                        <div class="flex-fill text-end fw-normal" style="width: 50%;">
                            Total Selected (All Audiences): {{ number(allTotal) }} 
                            <img class="info-icon" src="/img/icons/avid-icons/info.svg" v-if="dedupe" data-bs-toggle="tooltip" :title="dedupeCount" alt=""></img>
                        </div>
                    </div>
                    <button class="btn btn-primary" v-on:click="nextStep()">
                        <span v-if="(currentLayerIndex + 1) < filteredCube.length">Next Step</span>
                        <span v-else><span v-if="canEdit('direct_mail')">Save and Continue</span><span v-else>Continue</span></span>
                    </button>
                    <button class="btn btn-secondary ms-3" @click="saveSelections()" :disabled="saving" v-if="canEdit('direct_mail')">
                        <span v-if="saving"><i class="fas fa-spinner fa-spin"></i> Saving Progress</span>
                        <span v-else>Save Progress</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { defineComponent } from 'vue';
    import SelectionArea from '@viselect/vanilla';
    import permissionsMixin from '../../mixins/permissions';

    export default defineComponent({
        name: 'PackageSelection',
        props: {
            packages: {
                type: Array,
                required: true
            },
            cubeData: {
                type: Array,
                required: true
            },
            dedupe: {
                type: Boolean,
                default: false
            },
            axis_list: {
                type: Array,
                required: true
            }
        },
        mixins: [permissionsMixin],
        data() {
            return {
                dedupeCount: 'This number may includes duplicates. Accurate count will be calculated on Step 5.',
                package: {},
                selection: null,
                selectedLayer: this.cubeData && this.cubeData.length > 0 ? this.cubeData.findIndex(layer => 
                    layer && layer.data && layer.data.some(row => 
                        row && row.data && row.data.some(column => column && column.count > 0)
                    )
                ) : 0,
                saving: false,
                cube: this.cubeData || []
            }
        },
        computed: {
            allTotal() {
                let total = 0;
                this.cube.forEach(function(side) {
                    side.footer.data.forEach(function (item) {
                        total += item.selected;
                    })
                });
                return total;
            },
            filteredCube: function() {
                if (!this.cube || !Array.isArray(this.cube)) {
                    return [];
                }
                return this.cube.filter(layer => {
                    // Check if any column in any row has a non-zero count
                    return layer && layer.data && layer.data.some(row => 
                        row && row.data && row.data.some(column => column && column.count > 0)
                    );
                });
            },
            currentLayerIndex: function() {
                // Find the index of the current layer in the filtered cube
                if (!this.cube || !this.cube[this.selectedLayer]) {
                    return 0;
                }
                return this.filteredCube.findIndex(layer => 
                    layer === this.cube[this.selectedLayer]
                );
            }
        },
        watch: {
            cubeData: {
                handler(newCubeData) {
                    this.cube = newCubeData;
                    this.selectedLayer = this.cube.findIndex(layer => 
                        layer && layer.data && layer.data.some(row => 
                            row && row.data && row.data.some(column => column && column.count > 0)
                        )
                    );
                },
                immediate: true
            }
        },
        mounted() {
            this.selection = new SelectionArea({
                class: 'selection',
                selectables: ['.package-selection .selectable'],
                boundaries: ['.package-selection table'],
                startareas: ['html'],
                startThreshold: 10,
                disableTouch: false,
                container: '.package-selection',
                selectByClick: true,
                disableTextSelection: true,
                behavior: {
                    overlap: 'keep'
                }
            });

            this.selection
                .on('beforestart', this.startSelection)
                .on('move', this.moveSelection)
                .on('stop', this.stopSelection);

            this.saving = false;

            // Select the first package if none are selected
            if (this.packages && this.packages.length > 0) {
                const hasSelected = this.packages.some(pack => pack.selected);
                if (!hasSelected) {
                    this.selectPackage(this.packages[0]);
                }
            }
        },
        beforeUnmount() {
            if (this.selection) {
                this.selection
                    .off('beforestart', this.startSelection)
                    .off('move', this.moveSelection)
                    .off('stop', this.stopSelection);
                this.selection.destroy();
            }
        },
        methods: {
            getTitle(title) {
                //Loop through axis_list. Find the alue the matches title and return name
                for(let i = 0; i < this.axis_list.length; i++) {
                    if(this.axis_list[i].value === title) {
                        return this.axis_list[i].name;
                    }
                }
                return title;
            },
            selectPackage(pack) {
                if(!this.canEdit('direct_mail')) {
                    return;
                }

                this.packages.forEach(function(item) {
                    item.selected = false;
                });
                pack.selected = true;
                this.package = pack;
            },
            hasSelectedPackage() {
                return Object.keys(this.package).length;
            },
            startSelection(evt) {
                //console.log('startSelection', evt.selected);
            },
            moveSelection(evt) {
                if (!evt.selection || !evt.store) return;
                
                const added = evt.store.changed.added || [];
                const removed = evt.store.changed.removed || [];

                //Dedupe the array of added and removed against the evt.store.stored array (remove those in both)
                const dedupedAdded = added.filter(item => !removed.includes(item));
                const dedupedRemoved = removed.filter(item => !added.includes(item));
                
                // Add the elements that where selected
                for (const el of dedupedRemoved) {
                    el.dispatchEvent(new Event('select'));
                }

                // Remove the elements that where removed since the last selection
                for (const el of dedupedAdded) {
                    el.dispatchEvent(new Event('deselect'));
                }
            },
            stopSelection(evt) {        
                evt.store.stored = [];
            },
            selectData(data, z, x, y) {
                if (!this.canEdit('direct_mail')) {
                    return;
                }

                const is_selected = (data.package_id != null);

                if(data.package_id === this.package.id) {
                    this.deselectData(data, z, x, y);
                    return;
                }

                if (this.hasSelectedPackage()) {
                    //If the square was already selected
                    if (is_selected) {
                        let cost = 0;
                        //Get the old cost
                        this.packages.forEach(function(item) {
                            if(item.id === data.package_id) {
                                if(item.experiment && item.experiment_cost > 0)
                                    cost = item.cost/2 + item.experiment_cost/2;
                                else
                                    cost = item.cost;
                            }
                        });
                        this.cube[z].data[x].cost = (this.cube[z].data[x].cost || 0) - cost*data.count;
                        this.cube[z].footer.data[y].cost = (this.cube[z].footer.data[y].cost || 0) - cost*data.count;
                    }

                    data.color = this.package.color;
                    data.package_id = this.package.id;
                    if(this.package.experiment && this.package.experiment_cost > 0)
                        data.cost = this.package.cost/2 + this.package.experiment_cost/2;
                    else
                        data.cost = this.package.cost;

                    data.selected = true;
                    //Only add in counts if it was not already selected
                    if (!is_selected) {
                        this.cube[z].data[x].selected = (this.cube[z].data[x].selected || 0) + data.count;
                        this.cube[z].footer.data[y].selected = (this.cube[z].footer.data[y].selected || 0) + data.count;
                    }
                    this.cube[z].data[x].cost = (this.cube[z].data[x].cost || 0) + data.count*data.cost;
                    this.cube[z].footer.data[y].cost = (this.cube[z].footer.data[y].cost || 0) + data.count*data.cost;
                }
            },
            deselectData(data, z, x, y) {
                if (!this.canEdit('direct_mail')) {
                    return;
                }

                const is_selected = (data.package_id != null);
                if(!is_selected || data.package_id !== this.package.id) {
                    this.selectData(data, z, x, y);
                    return;
                }

                if (this.hasSelectedPackage()) {
                    let cost = 0;
                    //Get the cost of the package that was actually selected
                    this.packages.forEach(function(item) {
                        if(item.id === data.package_id) {
                            if(item.experiment && item.experiment_cost > 0)
                                cost = item.cost/2 + item.experiment_cost/2;
                            else
                                cost = item.cost;
                        }
                    });
                    
                    data.color = "";
                    data.package_id = null;
                    data.cost = 0;
                    if (is_selected) {
                        data.selected = false;
                        this.cube[z].data[x].selected = Math.max(0, (this.cube[z].data[x].selected || 0) - data.count);
                        this.cube[z].footer.data[y].selected = Math.max(0, (this.cube[z].footer.data[y].selected || 0) - data.count);
                        this.cube[z].data[x].cost = Math.max(0, (this.cube[z].data[x].cost || 0) - data.count*cost);
                        this.cube[z].footer.data[y].cost = Math.max(0, (this.cube[z].footer.data[y].cost || 0) - data.count*cost);
                    }
                }
            },
            totalCost(z) {
                let total = 0;
                this.cube[z].footer.data.forEach(function(item) {
                    total += (item.cost || 0);
                });
                return total;
            },
            totalSelected(z) {
                let total = 0;
                this.cube[z].footer.data.forEach(function(item) {
                    total += (item.selected || 0);
                });
                return total;
            },
            saveSelections(final = false) {
                if (!this.canEdit('direct_mail')) {
                    this.$emit('next-step');
                    return;
                }

                const self = this;
                this.saving = true;

                axios.post('/api/direct_mail/audience', {cube: self.cube}).then((res) => {
                    if (final) {
                        self.$emit('next-step');
                    }
                    else self.saving = false;
                });
            },
            nextStep() {

                var self = this;

                // Find the next non-empty layer
                let nextIndex = this.selectedLayer + 1;
                while (nextIndex < this.cube.length) {
                    const layer = this.cube[nextIndex];
                    const hasData = layer && layer.data && layer.data.some(row => 
                        row && row.data && row.data.some(column => column && column.count > 0)
                    );
                    if (hasData) {
                        this.selectedLayer = nextIndex;
                        break;
                    }
                    nextIndex++;
                }

                if (nextIndex >= this.cube.length) {
                    this.saveSelections(true);
                }
            },
            getTextColorClass(backgroundColor) {
                // Remove the # if it exists
                let hex = backgroundColor.replace('#', '');
                
                // Convert to standard 6-character format if in 3-character shorthand
                if (hex.length === 3) {
                    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                }
                
                // Convert to RGB
                const r = parseInt(hex.substring(0, 2), 16);
                const g = parseInt(hex.substring(2, 4), 16);
                const b = parseInt(hex.substring(4, 6), 16);
                
                // Calculate perceived brightness using the YIQ formula
                // This formula gives a perceived brightness value between 0 and 255
                // It weights the RGB components based on human perception
                const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
                
                // Return black for light backgrounds, white for dark backgrounds
                return yiq >= 128 ? '' : 'text-white';
            }
        }
    });
</script>

<style scoped>
.package-selection .button-wrapper {
    border-radius: 20px;
    flex-wrap: wrap; /* keep existing flex behavior, but allow stacked rows */
}

/* The Bootstrap .row/.col-* structure adds negative margins/gutters; neutralize inside the flex wrapper */
.package-selection .button-wrapper > .row {
    flex: 0 0 100%;
    width: 100%;
    margin-left: 0;
    margin-right: 0;
}

.package-selection .button-wrapper > .row > [class*="col-"] {
    padding-left: 0;
    padding-right: 0;
}

/* Make the info strip span the full inner width and sit flush with the rounded border (padding is 15px in direct_mail.scss) */
.package-selection .button-wrapper .button-wrapper-info {
    width: 100%;
    flex: 0 0 100%;
    margin: 10px -15px -15px;
    padding: 0 15px;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
}
</style>